import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobusAuth } from '@globus/react-auth-context';


const GlobusRedirect = () => {
    const { isAuthenticated, authorization } = useGlobusAuth();
    const navigate = useNavigate();

    useEffect(() => {
        async function attempt() {
            if (!authorization) {
                return;
            }
            if (isAuthenticated) {
                navigate("/globus-collections")
                return;
            }
            /**
             * Attempt to handle incoming OAuth2 redirect.
             */
            await authorization.handleCodeRedirect({
                shouldReplace: false,
            });

            navigate("/globus-collections")

        }
        attempt();
    }, [authorization, authorization?.handleCodeRedirect, isAuthenticated]);

    return (
        <>
        </>
    )
}

export default GlobusRedirect;